/*
  Studio Fedde · opmaak van de Delm-levertijdwidget (productpagina's, winkelmandje en cart drawer).

  De Delm-widget zit in een shadow-DOM, dus gewone CSS bereikt hem niet. Dit script zet in elke <delm-widget> een
  stijlregel met de huisstijl (Roboto Light, Studio Green #3C3D2B, Sand #D0CDBC, Cream #F7F2ED), laat de tijdlijn de
  volle breedte gebruiken en verbergt de grote datum bovenaan zodat de leverdatum maar één keer staat (in de tijdlijn).
  Het kijkt mee naar nieuwe widgets (andere variant gekozen, drawer of winkelmandje opnieuw opgebouwd) en zet de regel
  terug als de widget zijn inhoud ververst.

  De regels hangen aan Delm's interne klassenamen (.delm-widget__*) en aan de positie van de kop. Breekt de opmaak na een
  Delm-update, kijk dan eerst daar. Alle teksten en datums blijven van Delm zelf.
*/
(function () {
  if (window.sfDelmWidgetStyle) return;
  window.sfDelmWidgetStyle = true;

  var CSS = [
    /* Eén datum: de grote regel bovenaan verbergen, de datum in de tijdlijn blijft */
    '.delm-widget > div:first-child > div:nth-child(2) { display: none; }',
    /* Studio Fedde huisstijl */
    '.delm-widget { color: #3C3D2B; font-weight: 300; line-height: 1.35; }',
    '.delm-widget > div:first-child { margin-bottom: 14px !important; }',
    '.delm-widget > div:first-child > div:first-child { font-size: 11px; font-weight: 400; letter-spacing: 0.15em; text-transform: uppercase; }',
    '.delm-widget__date { font-weight: 400; margin-bottom: 3px; }',
    '.delm-widget__column > div:not([class]) { font-size: 13px; color: rgba(60, 61, 43, 0.7); }',
    /* Tijdlijn over de volle breedte: de linkerkolom krijgt de ruimte van zijn tekst, de rest gaat naar rechts */
    '.delm-widget__timeline { width: 100%; }',
    '.delm-widget__column { width: auto; flex: 1 1 0; min-width: 0; }',
    '.delm-widget__column:first-child:not(:last-child) { flex: 0 0 auto; max-width: 50%; }',
    '.delm-widget__column:last-child .delm-widget__date { white-space: nowrap; }',
    '.delm-widget__line { border-bottom: 1px solid #D0CDBC; }',
    '.delm-widget__icon { background-color: #D0CDBC; }',
    '.delm-widget__icon svg { fill: #3C3D2B; }',
    '.delm-widget__column:last-child .delm-widget__icon { background-color: #3C3D2B; }',
    '.delm-widget__column:last-child .delm-widget__icon svg { fill: #F7F2ED; }',
    /* Staat er al een kop boven de widget (winkelmandje met werkblad: "Levering fronten"), dan is het label "Levering" dubbel */
    ':host([data-sf-hide-title]) .delm-widget > div:first-child { display: none; }'
  ].join(' ');

  function patch(el) {
    var sr = el.shadowRoot;
    if (!sr) return false;
    function ensure() {
      if (!sr.querySelector('style[data-sf-delm]')) {
        var s = document.createElement('style');
        s.setAttribute('data-sf-delm', '');
        s.textContent = CSS;
        sr.appendChild(s);
      }
    }
    ensure();
    new MutationObserver(ensure).observe(sr, { childList: true });
    el.setAttribute('data-sf-delm', '');
    return true;
  }

  function scan() {
    document.querySelectorAll('delm-widget:not([data-sf-delm])').forEach(function (el) {
      var tries = 0;
      (function attempt() {
        if (!patch(el) && tries++ < 50) setTimeout(attempt, 100);
      })();
    });
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan();
})();
